import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Container, Card, CardContent, LinearProgress, makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
  },
  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(4),
  },
  progress: {
    transition: theme.transitions.create(['height']),
    height: 0,
  },
  progressShow: {
    height: 4,
  },
}));

const AuthPage = ({ children, isLoading }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth="sm" className={classes.container}>
        <Card raised className={classes.card}>
          <LinearProgress
            className={clsx(classes.progress, {
              [classes.progressShow]: isLoading,
            })}
          />
          <CardContent>
            {children}
          </CardContent>
        </Card>
      </Container>
    </div>
  );
};

AuthPage.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
};

AuthPage.defaultProps = {
  isLoading: false,
};

export default AuthPage;
